let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("IZf4J")]).then(() => parcelRequire('kQUup'));